"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRelay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const router_1 = __importStar(require("next/router"));
const react_1 = require("react");
const react_relay_1 = require("react-relay");
const relay_runtime_1 = require("relay-runtime");
const json_meta_1 = require("./json_meta");
// Enabling this feature flag to determine if a page should 404 on the server.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
relay_runtime_1.RelayFeatureFlags.ENABLE_REQUIRED_DIRECTIVES = true;
function defaultVariablesFromContext(ctx) {
    return ctx.query;
}
function defaultQueryOptionsFromContext(_ctx) {
    return { fetchPolicy: 'store-or-network' };
}
function useStableIdentity(nextValue) {
    const lastValue = (0, react_1.useRef)(nextValue);
    return (0, react_1.useMemo)(() => {
        if (!(0, lodash_isequal_1.default)(lastValue.current, nextValue)) {
            lastValue.current = nextValue;
        }
        return lastValue.current;
    }, [nextValue]);
}
function withRelay(Component, query, opts) {
    const { queryOptionsFromContext = defaultQueryOptionsFromContext, variablesFromContext = defaultVariablesFromContext, } = opts;
    function useLoadedQuery(initialPreloadedQuery) {
        const router = (0, router_1.useRouter)();
        const queryOptions = useStableIdentity((0, react_1.useMemo)(() => queryOptionsFromContext(router), [router]));
        const queryVariables = useStableIdentity((0, react_1.useMemo)(() => variablesFromContext(router), [router]));
        const [preloadedQuery, setPreloadedQuery] = (0, react_1.useState)(initialPreloadedQuery);
        const isMountedRef = (0, react_1.useRef)(false);
        const env = (0, react_relay_1.useRelayEnvironment)();
        (0, react_1.useEffect)(() => {
            // Avoid re-setting the initial preloaded query on the first render.
            if (!isMountedRef.current) {
                isMountedRef.current = true;
                return;
            }
            const nextPreloadedQuery = (0, react_relay_1.loadQuery)(env, query, queryVariables, queryOptions);
            setPreloadedQuery(nextPreloadedQuery);
            return () => nextPreloadedQuery.dispose();
        }, [env, queryVariables, queryOptions]);
        return preloadedQuery;
    }
    function RelayComponent(props) {
        var _a;
        const preloadedQuery = useLoadedQuery(props.preloadedQuery);
        return ((0, jsx_runtime_1.jsx)(react_1.Suspense, Object.assign({ fallback: (_a = opts.fallback) !== null && _a !== void 0 ? _a : 'Loading...' }, { children: (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props, { preloadedQuery: preloadedQuery })) })));
    }
    RelayComponent.getInitialProps = relayInitialProps(query, opts);
    return RelayComponent;
}
exports.withRelay = withRelay;
function relayInitialProps(query, opts) {
    return (ctx) => __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined') {
            return getServerInitialProps(ctx, query, opts);
        }
        else {
            return getClientInitialProps(ctx, query, opts);
        }
    });
}
function getServerInitialProps(ctx, query, opts) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { variablesFromContext = defaultVariablesFromContext, queryOptionsFromContext = defaultQueryOptionsFromContext, } = opts;
        const serverSideProps = opts.serverSideProps
            ? yield opts.serverSideProps(ctx)
            : {};
        if ('redirect' in serverSideProps) {
            const { redirect } = serverSideProps;
            let statusCode = 302;
            if ('statusCode' in redirect) {
                statusCode = redirect.statusCode;
            }
            else if ('permanent' in redirect) {
                statusCode = redirect.permanent ? 308 : 307;
            }
            ctx
                .res.writeHead(statusCode, {
                Location: redirect.destination,
            })
                .end();
            return { CSN: false };
        }
        const env = yield opts.createServerEnvironment(ctx, serverSideProps);
        const variables = variablesFromContext(ctx);
        const queryOptions = queryOptionsFromContext(ctx);
        const preloadedQuery = (0, react_relay_1.loadQuery)(env, query, variables, queryOptions);
        const payload = yield ensureQueryFlushed(preloadedQuery);
        yield ((_a = opts.serverSidePostQuery) === null || _a === void 0 ? void 0 : _a.call(opts, payload, ctx));
        const payloadSerializationMetadata = (0, json_meta_1.collectMeta)(payload);
        const request = query;
        const operationDescriptor = (0, relay_runtime_1.createOperationDescriptor)('default' in request ? request.default : request, variables);
        const props = Object.assign(Object.assign({}, serverSideProps), { CSN: false, operationDescriptor,
            payload, payloadMeta: payloadSerializationMetadata });
        // This will only be available during SSR, not during client side render or hydration.
        Object.defineProperty(props, 'preloadedQuery', {
            enumerable: false,
            value: preloadedQuery,
        });
        return props;
    });
}
function getClientInitialProps(ctx, query, opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const { variablesFromContext = defaultVariablesFromContext, queryOptionsFromContext = defaultQueryOptionsFromContext, } = opts;
        const clientSideProps = opts.clientSideProps
            ? opts.clientSideProps(ctx)
            : {};
        if ('redirect' in clientSideProps) {
            void router_1.default.push(clientSideProps.redirect.destination);
            return { CSN: true };
        }
        const env = opts.createClientEnvironment();
        const variables = variablesFromContext(ctx);
        const queryOptions = queryOptionsFromContext(ctx);
        const preloadedQuery = (0, react_relay_1.loadQuery)(env, query, variables, queryOptions);
        return Object.assign(Object.assign({}, clientSideProps), { CSN: true, preloadedQuery });
    });
}
function ensureQueryFlushed(query) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            if (query.source == null) {
                resolve({ data: {} });
            }
            else {
                query.source.subscribe({
                    next: resolve,
                    error: reject,
                });
            }
        });
    });
}
